import React, { Component, Fragment } from 'react';
import {
  PlusSquareOutlined,
  UploadOutlined,
  DownOutlined,
} from '@ant-design/icons';
import { Progress, Tooltip, Tree } from 'antd';
import { RESULT, IMPORT, COMPARE, HISTORY, WAVEFORM_EXP_CHECK, SUB_TITLE, resultTreeCurveNodeTitle, END_TO_END, VICTIM } from './nodeRender';
import "../../publicCss/style.css";
import "./index.css";
import { strDelimited } from '../../services/helper/split';
import { SIERRA } from '../../constants/pageType';

/**
 * resultList: { displayMode: { show: [rowName], list : [] } }
 * resultList[displayMode].list: [{ rowName, children: [] }]
 * resultList[displayMode].list[N].children: [{ id, name, color }]
 * multiFiles ->  resultList[fileId][displayMode]
 * 
 * Tree 
 * 1. selectable - false
 * 2. checkable - true,  need to set the node that does not need to be checked to false separately 
 * 3. expandedKeys - [], need to specify the default expanded Nodes, props
 * 4. checkedKeys - [], portSelect, Automatic conversion according to portSelect,Only the checkedKeys of the port are needed, for example, the key of the parent node signal is not needed.
 *     portSelect - { Signal1 : [ portId1, portId2 ...], Signal2 : [ portId3, portId4 ...]}
 *     checkedKeys - [ portId1,portId2, portId3, portId4 ]
 *     Customize: getTreeCheckedKeys
 * 5. onCheck:checkKeysChange -> checked curve
 *     1. The port node only needs to get the parentKey (signal node ID) -> signal1 / signal1::fileId ...
 *     2. The signal node will get all children (port nodes)
 *     3. Customize the prop's checkChange method as needed - changeTreeCheckedKeys 
 * 6. checkStrictly - default is false. sierra sweep is true
 * 7. titleRender -> this.resultTreeRender and Customize resultTreeRender
 * 8. getTreeData 
 * 9. treeData ->Required Key, unique identifier key -> "id", fieldNames={{ title: "title", key: "id", children: "children" }}
 * 10. tree node title
 */
class ResultTreeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  stopPropagation = (e) => {
    e && e.stopPropagation() && e.preventDefault()
  }

  getList = (id) => {
    const { multiFiles, resultList, handleResultList, displayMode, } = this.props;

    //resultTitleList - [Result, History, Comparison, Import,... ] 
    //filesObj - {Result: files, History: files, Comparison: files,Import: files  } -> resultList[fileId][displayMode]
    //!multiFiles ->  resultList[displayMode]
    //multiFiles ->  resultList[fileId][displayMode]
    //resultList: multiFiles ->{ fileRowName:{ [displayMode]:{list, show} } } ->!multiFiles: { [displayMode]:{list, show}, [id]: {list, show } }
    let obj = {};
    if (multiFiles) {
      obj = (resultList[id] && resultList[id][displayMode]) || {};
    } else {
      obj = resultList[displayMode] || {};
    }

    if (Object.prototype.toString.call(handleResultList) === '[object Function]') {
      //andes todo
      obj = handleResultList(obj, id);
    }

    const list = obj.list || [];
    const updateTitles = (data) =>
      data.map(item => ({
        ...item,
        title: item.title || "",//Add a default title to prevent the span title attribute of antd's tree node from being displayed as "---"
        children: item.children ? updateTitles(item.children) : undefined
      }));

    return updateTitles(list);
  }

  getTreeData = () => {
    //resultTitleList - [Result, History, Comparison, Import,... ] 
    //filesObj - {Result: files, History: files, Comparison: files,Import: files  } -> resultList[fileId][displayMode]
    //!multiFiles ->  resultList[displayMode]
    //multiFiles ->  resultList[fileId][displayMode]

    const { filesObj = {}, multiFiles, displayMode, resultTitleList, isParallel, type } = this.props;

    // resultTitleList = [Result, History, Comparison, Import ] 
    let _resultTitleList = resultTitleList && resultTitleList.length ? resultTitleList : [type];

    let treeData = [];
    // obj.list = [{key, title, children ,id , ... }]
    //obj.show = selected list key
    for (let key of _resultTitleList) {
      let resultItem = {
        id: key,
        title: key,
        type: key,
        children: [],
        checkable: false,
        className: "result-tree-node-total-title",
      }
      if (multiFiles) {
        const files = filesObj[key] || [];
        for (let file of files) {
          const list = this.getList(file.rowId);//get list by rowId/id/fileId ...
          resultItem.children.push({
            ...file,
            type: SUB_TITLE,
            checkable: false,
            children: list,
            className: "result-tree-node-sub-title-content",
            title: ""
          })
        }
      } else {
        const list = this.getList();
        resultItem.children = JSON.parse(JSON.stringify(list || []));
        //waveform sweep exp checkbox row
        if (displayMode === "Waveform" && isParallel) {
          resultItem.children.unshift({ id: WAVEFORM_EXP_CHECK, title: "", type: WAVEFORM_EXP_CHECK, checkable: false })
        }
      }
      treeData.push(resultItem)
    }
    return treeData;
  }

  iconRender = (type) => {
    const { importProgress } = this.state;
    switch (type) {
      case IMPORT:
        return (
          <Fragment>
            <UploadOutlined
              className={`result-tree-import-button ${importProgress > -1 ? 'result-tree-import-icon-disabled' : ''}`}
              title='Upload file'
              onClick={(e) => importProgress > -1 ? this.stopPropagation(e) : this.uploadFile(e)} />
            {importProgress > -1 && <Progress
              size={{ height: 14 }}
              strokeColor={'#1890ff'}
              percent={importProgress}
              className="result--tree-progress-bar"
            />}
          </Fragment>
        );
      case COMPARE:
        return (
          <Fragment>
            <PlusSquareOutlined
              className={`result-tree-import-button`}
              title='Add tasks to compare'
              onClick={(e) => this.showCompareAdd(e, true)} />
          </Fragment>
        );
      case RESULT:
      case HISTORY:
      default:
        return;
    }
  }

  titleRender = (nodeData) => {
    let children = null;

    const { resultTreeRender, resultTitleRender, isParallel } = this.props;

    switch (nodeData.type) {
      case RESULT:
      case IMPORT:
      case COMPARE:
      case HISTORY:
      case END_TO_END:
      case VICTIM:
        children = <div className='result-tree-list-main-title'>
          <span className={isParallel ? "result-tree-list-title result-tree-sweep-list-title" : "result-tree-list-title"}>
            {nodeData.title || nodeData.key}
            {/* Solve the issue that data cannot be covered when scrolling */}
            {isParallel ? <div className="placeholder-elements"></div> : null
            }
          </span >
          {this.iconRender(nodeData.key)}
          {nodeData.type === RESULT && resultTitleRender ? resultTitleRender(nodeData, this.action()) : null}
        </div >;
        break;
      case SUB_TITLE:
        children = <Tooltip
          classNames={{
            root: 'aurora-tooltip',
          }}
          placement="topLeft"
          title={nodeData.title || nodeData.rowName || nodeData.name || ""}
        >
          <div className='result-tree-list-main-sub-title'>{nodeData.title || nodeData.rowName || nodeData.name || ""}</div>
        </Tooltip>
        break;
      default:
        if (!nodeData.children) {
          //curve item
          children = resultTreeCurveNodeTitle(nodeData, this.action());
          break;
        }
        children = nodeData.title || nodeData.rowName || nodeData.name || "";
        break;
    }

    if (resultTreeRender) {
      const _children = resultTreeRender(nodeData, this.action());
      if (_children) {
        children = _children;
      }
    }

    return <div
      onClick={(e) => {
        e && e.stopPropagation();//Clicking the checkbox triggers the selection/un-selection operation, while clicking the text does not trigger it
      }}>
      {children}
    </div>
  }

  action = () => {
    return {
      ...this.props,
      stopPropagation: this.stopPropagation
    }
  }

  checkKeysChange = (checkedKeys, e) => {
    const nodeData = e.node;
    if (!nodeData) {
      return;
    }
    const checked = e.checked;
    const parentKey = nodeData.parentKey;//rowName, if node is a curve node, if s-parameter parentKey is rowName@fileId

    const { changeTreeCheckedKeys } = this.props;
    if (changeTreeCheckedKeys) {
      //custom checkbox
      changeTreeCheckedKeys({ checked, nodeData });
      return;
    }

    //curve node
    const { portSelect, changePort } = this.props;
    if (!changePort) {
      return;
    }
    const _portSelect = portSelect || {};
    //By default, there are only two layers of checkable trees. parentKey is the key of the rowName node. key is curve id, and the rowName node has children
    // portSelect key -> {key: values, } -> key is rowName, values is curve id list
    if (nodeData.children) {
      //row Name node 
      const rowId = this.getRowId(nodeData.id);
      const prevValues = [...(_portSelect[rowId] || [])];
      const currAllValues = nodeData.children.map(item => item.id);
      //preValues -> same row name, but different row parent(PCB);   
      const values = checked ? [...new Set([...prevValues, ...currAllValues])] : prevValues.filter(item => !currAllValues.includes(item));
      changePort(values, rowId);
    } else {
      //curve node
      const rowId = this.getRowId(parentKey);
      const prevValues = [...(_portSelect[rowId] || [])];
      const values = checked ? [...prevValues, nodeData.id] : prevValues.filter(item => item !== nodeData.id);
      changePort(values, rowId);
    }
  }

  getRowId = (rowId) => {
    const { product } = this.props;
    if (product === SIERRA) {
      //signalName::fileId -> sierra s-parameter
      //signalNameId::rowId -> sierra s-parameter end-to-end
      return strDelimited(rowId, "::")[0];
    }
    return rowId;
  }

  getCheckedKeys = () => {
    const { portSelect, getTreeCheckedKeys, checkStrictly } = this.props;
    const _portSelect = portSelect || {};
    if (getTreeCheckedKeys && checkStrictly) {
      //custom checked and checkStrictly is true
      return getTreeCheckedKeys() || { checked: [], halfChecked: [] };
    }
    if (getTreeCheckedKeys) {
      //custom checked
      return getTreeCheckedKeys() || [];
    }
    return Object.keys(_portSelect).map(key => [...(_portSelect[key] || [])]).flat(2);
  }

  onExpand = (expandedKeys) => {
    this.props.updateExpandKeys(expandedKeys)
  }

  render() {
    const { className = '', expandedKeys = [], checkStrictly } = this.props;
    const treeData = this.getTreeData();
    const checkedKeys = this.getCheckedKeys();
    return (
      <div className={`result-tree-list-content ${className}`}>
        <Tree
          className='result-tree'
          switcherIcon={<DownOutlined />}
          checkable={true}
          selectable={false}
          checkStrictly={checkStrictly || false}
          treeData={treeData}
          checkedKeys={checkedKeys}
          expandedKeys={expandedKeys}
          fieldNames={{ title: "title", key: "id", children: "children" }}
          indent={4}
          onCheck={this.checkKeysChange}
          titleRender={this.titleRender}
          onExpand={this.onExpand}
        />
      </div>
    );
  };
}

export default ResultTreeList;